import Manifest from '../Manifest';

const mapManifestsToSchema = manifestItems =>
    manifestItems
        .map(item =>
            ({
                name: item.cdnName,
                url: item.manifestUrl,
            })
        )
        .map(manifest => Object.assign(new Manifest(), manifest));

export default mapManifestsToSchema;
